import { actions } from '../../utils/constants';

export const asyncFetchQuestionToDuplicate = ({ questionId }) => ({
    type: actions.ASYNC_FETCH_QUESTION_TO_DUPLICATE,
    payload: { questionId },
});



// WEBPACK FOOTER //
// ./src/components/duplicate-question/duplicate-question.actions.js